import React, { useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  List,
  AccordionSummary,
  Grid,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandMore';

const AccordionSummaryWrapper = styled(AccordionSummary)(
  ({ theme }) => `
    &.Mui-expanded {
      min-height: 48px;
    }

    .MuiAccordionSummary-content.Mui-expanded {
      margin: 12px 0;
    }

    .MuiSvgIcon-root {
      transition: ${theme.transitions.create(['color'])};
    }

    &.MuiButtonBase-root {

      margin-bottom: ${theme.spacing(0.5)};

      &:last-child {
        margin-bottom: 0;
      }

      &.Mui-expanded,
      &:hover {
        background: ${theme.colors.alpha.black[10]};

        .MuiSvgIcon-root {
          color: ${theme.colors.primary.main};
        }
      }
    }
`
);

function AccordionItem(props) {
  const [expanded, setExpanded] = useState<string | false>('section1');
  const [openByDefault, setOpen] = useState(props.open || false);
  const [alwaysOpen, setAlwaysOpen] = useState(props.alwaysOpen || false);
  const tmp = () => { }
  const onChange: Function = props.onChange || tmp;

  const handleChangeSection = (section: string) => (
    _event: React.SyntheticEvent,
    isExpanded: boolean
  ) => {
    if (!alwaysOpen) {
      setExpanded(isExpanded ? section : false);
      setOpen(isExpanded ? true : false);
      onChange();
    }
  };

  return (
    <Accordion
      expanded={expanded === 'section2' || openByDefault}
      onChange={handleChangeSection('section2')}
      style={{
        marginBottom: 10,
        marginLeft: 12,
        marginRight: 12
      }}
    >

      <AccordionSummaryWrapper
        style={{
          backgroundColor: '#00b0be',
          color: '#ffffff',
          textTransform: 'uppercase',
          height: 18
        }}
        expandIcon={
          <ExpandCircleDownIcon
            style={{
              color: '#ffffff'
            }}
          />
        }>
        <Grid container direction="row"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12}
            style={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <span>
              <img alt="Icon" src={"/static/images/tools/" + props.icon} style={{ width: 22, height: 22, marginTop: 5 }} />
            </span>
            &nbsp;&nbsp;&nbsp;
            <span style={{ fontWeight: 700, fontFamily: 'Poppins', justifyContent: "center", alignItems: "center" }}>
              {props.title}
            </span>
          </Grid>
        </Grid>
      </AccordionSummaryWrapper>
      <AccordionDetails
        sx={{
          p: 0
        }}
      >
        <List component="nav"
          style={{
            paddingTop: 0
          }}
        >
          {props.accordionContent}
        </List>
      </AccordionDetails>

    </Accordion >

  );
}

export default AccordionItem;